// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IInvestmentHoldingDetailsDto } from './IInvestmentHoldingDetailsDto';
import {
    IInvestmentHoldingDetailsDtoFromJSON,
    IInvestmentHoldingDetailsDtoFromJSONTyped,
    IInvestmentHoldingDetailsDtoToJSON,
    IInvestmentHoldingDetailsDtoToJSONTyped,
} from './IInvestmentHoldingDetailsDto';

/**
 * 
 * @export
 * @interface IInvestmentFundHoldingDetailsDto
 */
export interface IInvestmentFundHoldingDetailsDto extends IInvestmentHoldingDetailsDto {
    /**
     * 
     * @type {number}
     * @memberof IInvestmentFundHoldingDetailsDto
     */
    instrument_id?: number;
    /**
     * 
     * @type {string}
     * @memberof IInvestmentFundHoldingDetailsDto
     */
    status?: IInvestmentFundHoldingDetailsDtoStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof IInvestmentFundHoldingDetailsDto
     */
    image_url?: string;
    /**
     * 
     * @type {string}
     * @memberof IInvestmentFundHoldingDetailsDto
     */
    research_url?: string;
    /**
     * 
     * @type {string}
     * @memberof IInvestmentFundHoldingDetailsDto
     */
    type?: IInvestmentFundHoldingDetailsDtoTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof IInvestmentFundHoldingDetailsDto
     */
    shares?: number;
    /**
     * 
     * @type {number}
     * @memberof IInvestmentFundHoldingDetailsDto
     */
    share_price?: number;
    /**
     * 
     * @type {string}
     * @memberof IInvestmentFundHoldingDetailsDto
     */
    instrument_category_type?: IInvestmentFundHoldingDetailsDtoInstrumentCategoryTypeEnum;
}

/**
* @export
* @enum {string}
*/
export enum IInvestmentFundHoldingDetailsDtoStatusEnum {
    ACTIVE = 'ACTIVE',
    INACTIVE = 'INACTIVE',
    CLOSE_ONLY = 'CLOSE_ONLY',
    HALTED = 'HALTED'
}
/**
* @export
* @enum {string}
*/
export enum IInvestmentFundHoldingDetailsDtoTypeEnum {
    EQUITY = 'EQUITY',
    ETF = 'ETF',
    ADR = 'ADR',
    ETN = 'ETN',
    ALTERNATIVE_ASSET = 'ALTERNATIVE_ASSET',
    CRYPTO = 'CRYPTO',
    INTEREST_RATE = 'INTEREST_RATE',
    CYBER_SECURITY = 'CYBER_SECURITY',
    METALS = 'METALS',
    MUTUAL_FUND = 'MUTUAL_FUND'
}
/**
* @export
* @enum {string}
*/
export enum IInvestmentFundHoldingDetailsDtoInstrumentCategoryTypeEnum {
    SHORT_TERM_BOND = 'SHORT_TERM_BOND',
    INTERMEDIATE_CORE_BOND = 'INTERMEDIATE_CORE_BOND',
    INTERMEDIATE_CORE_PLUS_BOND = 'INTERMEDIATE_CORE_PLUS_BOND',
    INFLATION_PROTECTED_BOD = 'INFLATION_PROTECTED_BOD',
    GLOBAL_BOND = 'GLOBAL_BOND',
    HIGH_YIELD_BOND = 'HIGH_YIELD_BOND',
    LARGE_VALUE = 'LARGE_VALUE',
    LARGE_BLEND = 'LARGE_BLEND',
    LARGE_GROWTH = 'LARGE_GROWTH',
    MID_CAP_VALUE = 'MID_CAP_VALUE',
    MID_CAP_BLEND = 'MID_CAP_BLEND',
    MID_CAP_GROWTH = 'MID_CAP_GROWTH',
    SMALL_VALUE = 'SMALL_VALUE',
    SMALL_BLEND = 'SMALL_BLEND',
    SMALL_GROWTH = 'SMALL_GROWTH',
    REAL_ESTATE = 'REAL_ESTATE',
    FOREIGN_LARGE_BLEND = 'FOREIGN_LARGE_BLEND',
    FOREIGN_SMALL_MID_BLEND = 'FOREIGN_SMALL_MID_BLEND',
    DIVERSIFIED_EMERGING_MKTS = 'DIVERSIFIED_EMERGING_MKTS',
    MONEY_MARKET_FUND = 'MONEY_MARKET_FUND'
}


/**
 * Check if a given object implements the IInvestmentFundHoldingDetailsDto interface.
 */
export function instanceOfIInvestmentFundHoldingDetailsDto(value: object): value is IInvestmentFundHoldingDetailsDto {
    return true;
}

export function IInvestmentFundHoldingDetailsDtoFromJSON(json: any): IInvestmentFundHoldingDetailsDto {
    return IInvestmentFundHoldingDetailsDtoFromJSONTyped(json, false);
}

export function IInvestmentFundHoldingDetailsDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IInvestmentFundHoldingDetailsDto {
    if (json == null) {
        return json;
    }
    return {
        ...IInvestmentHoldingDetailsDtoFromJSONTyped(json, true),
        'instrument_id': json['instrument_id'] == null ? undefined : json['instrument_id'],
        'status': json['status'] == null ? undefined : json['status'],
        'image_url': json['image_url'] == null ? undefined : json['image_url'],
        'research_url': json['research_url'] == null ? undefined : json['research_url'],
        'type': json['type'] == null ? undefined : json['type'],
        'shares': json['shares'] == null ? undefined : json['shares'],
        'share_price': json['share_price'] == null ? undefined : json['share_price'],
        'instrument_category_type': json['instrument_category_type'] == null ? undefined : json['instrument_category_type'],
    };
}

export function IInvestmentFundHoldingDetailsDtoToJSON(json: any): IInvestmentFundHoldingDetailsDto {
    return IInvestmentFundHoldingDetailsDtoToJSONTyped(json, false);
}

export function IInvestmentFundHoldingDetailsDtoToJSONTyped(value?: IInvestmentFundHoldingDetailsDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        ...IInvestmentHoldingDetailsDtoToJSONTyped(value, true),
        'instrument_id': value['instrument_id'],
        'status': value['status'],
        'image_url': value['image_url'],
        'research_url': value['research_url'],
        'type': value['type'],
        'shares': value['shares'],
        'share_price': value['share_price'],
        'instrument_category_type': value['instrument_category_type'],
    };
}

